import { useQuery } from "@tanstack/react-query";
import { Smartphone, AlertTriangle } from "lucide-react";
import { api } from "@/lib/api";

export const PhoneStatusBadge = () => {
  const { data } = useQuery({ queryKey: ["coex-status"], queryFn: () => api.get("/coexistence/status").then((r) => r.data), refetchInterval: 60000 });
  if (!data?.onboarded && !data?.phone_last_active_at) return null;
  const when = data.phone_last_active_at ? new Date(data.phone_last_active_at).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : "mai";
  return (
    <span data-testid="phone-status-badge" title={data.warn ? "Apri l'app WhatsApp Business sul telefono: dopo 14 giorni Meta scollega la Coexistence" : "Ultima attività dell'app WhatsApp Business sul telefono"}
      className={`inline-flex items-center gap-1.5 text-[11px] font-semibold rounded-full px-2.5 py-1 border ${data.warn ? "bg-red-50 text-red-700 border-red-200" : "bg-[#DCFCE7] text-[#15803D] border-[#86EFAC]"}`}>
      {data.warn ? <AlertTriangle size={12} /> : <Smartphone size={12} />}
      Telefono aperto l'ultima volta il {when}{data.warn ? ` · ${data.days} giorni fa, aprilo!` : ""}
    </span>
  );
};
